import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Axios from "../apis/axios";
import { NodeId } from "components/NodeId";
import { produce } from "immer";
import mqtt from "mqtt";

class Deferred {
  promise: Promise<any>;
  resolve!: (value?: any) => void;
  reject!: (reason?: any) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

const liveDataSlice = (set: (data: any) => void, get: () => any) => ({
  streamResponse: {},

  
});

export default liveDataSlice;
